const AstraPayLogo = ({ height = 29, width = 27 }: { height?: number; width?: number }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1659 15.3052L18.3337 3.60556C15.9635 -0.453805 10.037 -0.453805 7.6659 3.60556L0.83461 15.3052C-1.53649 19.3645 1.42674 24.4389 6.16895 24.4389H19.8315C24.5729 24.4389 27.5361 19.3645 25.1659 15.3052Z"
        fill="#FFEB5A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0869 20.2018C17.8464 21.0375 15.8493 21.2548 14.3933 19.752L13.6299 18.9644C13.4791 18.8086 13.255 18.7193 13.0181 18.7193C12.7813 18.7193 12.5581 18.8086 12.4073 18.9644L11.5152 19.8843C10.8294 20.5919 9.91005 20.981 8.92685 20.981C8.41054 20.981 7.90446 20.874 7.42138 20.6626C6.03944 20.0553 5.24624 18.7673 5.35103 17.3007C5.39619 16.6858 5.57937 16.1012 5.89545 15.5604L9.47042 9.43811C10.2117 8.16951 11.5391 7.41222 13.019 7.41222C14.4998 7.41222 15.8255 8.16951 16.5658 9.43811L20.1425 15.5621C20.2081 15.675 20.2669 15.787 20.3189 15.8999C21.1709 17.7219 20.3138 19.3738 19.0869 20.2018ZM25.1659 15.3052L18.3337 3.60556C15.9635 -0.453805 10.037 -0.453805 7.6659 3.60556L0.83461 15.3052C-1.53649 19.3645 1.42674 24.4389 6.16894 24.4389H19.8315C24.5729 24.4389 27.5361 19.3645 25.1659 15.3052Z"
        fill="#0045E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7349 16.6233C18.7034 16.5567 18.6685 16.4893 18.6301 16.4228L15.056 10.2997C14.63 9.57271 13.8683 9.13721 13.0189 9.13721C12.1686 9.13721 11.4069 9.57271 10.9818 10.2997L7.40595 16.4245C7.22192 16.7378 7.11627 17.0731 7.09156 17.4227C7.03022 18.2853 7.58657 18.8471 8.12929 19.0847C8.87053 19.4115 9.70633 19.2557 10.2559 18.6896L11.1471 17.7706C12.1354 16.753 13.9024 16.753 14.889 17.7706L15.6524 18.5565C16.4115 19.3391 17.4297 19.2312 18.1027 18.7764C18.3106 18.6365 19.3194 17.8725 18.7349 16.6233Z"
        fill="#0045E5"
      />
    </svg>
  );
};

export { AstraPayLogo };
